import { Box, Card, CardContent, Container, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from '../LocaleSwitcher';
import BrandLogo from '../branding/BrandLogo';

const AuthPageShell = ({
  children,
  compact = false,
  onLogoClick,
  showTitle = true,
  subtitle,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        display: 'grid',
        alignItems: { xs: compact ? 'start' : 'center', sm: 'center' },
        py: compact ? { xs: 1.5, sm: 3 } : 4,
        background:
          'radial-gradient(circle at 24% 18%, rgba(215,160,75,0.22), transparent 24rem), radial-gradient(circle at 78% 82%, rgba(15,76,69,0.16), transparent 26rem)',
      }}
    >
      <Container maxWidth="xs">
        <Card variant="outlined" sx={{ borderRadius: 3 }}>
          <CardContent sx={{ p: compact ? { xs: 2, sm: 2.5 } : 3 }}>
            <Stack spacing={compact ? { xs: 1.5, sm: 2 } : 2.5}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <LanguageSwitch />
              </Box>
              <BrandLogo variant="stacked" compact={compact} onClick={onLogoClick} />
              <Box>
                {showTitle && title && (
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: compact ? { xs: '2.05rem', sm: '2.55rem' } : undefined,
                      lineHeight: compact ? 0.98 : undefined,
                    }}
                  >
                    {title}
                  </Typography>
                )}
                {subtitle && (
                  <Typography
                    color="text.secondary"
                    sx={{
                      fontSize: compact ? { xs: '1rem', sm: '1.05rem' } : undefined,
                      mt: compact ? 0.5 : undefined,
                    }}
                  >
                    {subtitle}
                  </Typography>
                )}
              </Box>
              {children}
              <Stack
                component="nav"
                direction="row"
                spacing={1.5}
                flexWrap="wrap"
                useFlexGap
                justifyContent="center"
                sx={{ pt: compact ? 0 : 1, rowGap: compact ? 0.25 : undefined }}
              >
                <Link component={RouterLink} to="/privacy" variant="body2">
                  {t('legalLinks.privacy')}
                </Link>
                <Link component={RouterLink} to="/terms" variant="body2">
                  {t('legalLinks.terms')}
                </Link>
                <Link component={RouterLink} to="/legal" variant="body2">
                  {t('legalLinks.legal')}
                </Link>
                <Link component={RouterLink} to="/privacy/contact" variant="body2">
                  {t('legalLinks.requests')}
                </Link>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default AuthPageShell;
